/**
 *
 * Die Runtime sollte so kurz wie möglich sein. Sie sollte als erstes
 * im <script></script> enhalten sein.
 *
 * - beim initialen attached schauen ob e.g url /hallo/du/da.html
 *   im übergebenen cachedRoute enthalten ist. Wenn ja handler
 *   aufrufen.
 * - bei click auf neue url, und wenn nichts mehr im cachedRoute nicht vorhanden,
 *   dann router.js laden und mit der runtime ersetezen
 *
 */